import MemoApplicationStatusSteps from "@/assets/ApplicationStatusSteps";
import { getFormatDate } from "@/helpers/getTimeAppliedAgo";
import {
  AwaitedResponse,
  SuccessFilled,
} from "@monsterindia/global-ui-components";
import React from "react";

interface ApplicationStatusProps {
  data: any;
  isMobile: boolean;
}

const ApplicationStatus: React.FC<ApplicationStatusProps> = ({
  data,
  isMobile,
}) => {
  return (
    <div className="pb-6 pt-5 md:p-6 md:!pb-8 md:!pt-4">
      <div className="flex flex-col gap-4 rounded-lg border border-[#E8E8EB] bg-white p-4">
        <div className="text-[16px] font-bold leading-[24px] text-black md:!text-[18px] md:!leading-[26px]">
          <p>Your application status</p>
        </div>
        <div className="">
          {data.map((status: any, index: number) => {
            return (
              <>
                {status.text == "Recruiter response" ? (
                  <>
                    <div className="flex w-[24px] justify-center">
                      <MemoApplicationStatusSteps
                        fill="#6E00BE"
                        width="2"
                        height="30"
                      />
                    </div>
                    <div className="flex gap-3">
                      <span className="self-start">
                        <AwaitedResponse width={24} height={24} fill="none" />
                      </span>
                      <p className="mt-[2px] text-[14px] font-normal leading-[20px] text-black">
                        {status.text}
                        <span className="ml-1 text-[10px] font-semibold leading-[14px] tracking-[0.4px] text-[#FFA000] md:!text-[12px] md:!leading-[16px] md:!tracking-normal">
                          (awaited)
                        </span>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex gap-3">
                      <span className="self-start">
                        <SuccessFilled
                          width={24}
                          height={24}
                          fill="#2BA682"
                          className="text-gumdropGreen-500"
                        />
                      </span>
                      <p className="mt-[2px] text-[14px] font-normal leading-[20px] text-black">
                        {status.text}{" "}
                        <span className="text-[12px] font-normal leading-[16px] text-[#777584]">
                          {`(${getFormatDate(status?.statusUpdatedAt)})`}
                        </span>
                      </p>
                    </div>
                    {data[index + 1] &&
                      data[index + 1].text !== "Recruiter response" && (
                        <div className="relative top-[1px] flex w-[24px] justify-center">
                          <MemoApplicationStatusSteps
                            fill="#2BA682"
                            width="2"
                            height="30"
                          />
                        </div>
                      )}
                  </>
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ApplicationStatus);
